import React, { ReactNode } from "react";

export interface DataTableCardProps {
  title?: ReactNode;
  /** Optional count rendered after the title as a "· N" suffix (Figma "Team Timesheets · N pending") */
  count?: number;
  toolbar?: ReactNode;
  children?: ReactNode;
  pagination?: ReactNode;
  className?: string;
}

const DataTableCard = ({
  title,
  count,
  toolbar,
  children,
  pagination,
  className = "",
}: DataTableCardProps) => {
  return (
    <div
      className={`bg-white rounded-[18px] border border-border-secondary shadow-xs overflow-hidden ${className}`}
    >
      {(title || toolbar) && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 px-4 sm:px-[22px] py-3.5 sm:py-[18px] border-b border-[var(--color-border-tertiary)]">
          {title && (
            <div className="text-[15px] sm:text-[16px] font-bold text-[var(--color-text-primary)]">
              {title}
              {count !== undefined && (
                <span className="text-[12px] sm:text-[13px] font-semibold text-[var(--color-text-tertiary)]">
                  {" "}
                  · {count}
                </span>
              )}
            </div>
          )}
          {toolbar && (
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:justify-end flex-wrap w-full sm:w-auto">
              {toolbar}
            </div>
          )}
        </div>
      )}
      <div className="px-0 py-0">{children}</div>
      {pagination && (
        <div className="px-5 py-3 border-t border-[var(--color-border-tertiary)]">
          {pagination}
        </div>
      )}
    </div>
  );
};

export default DataTableCard;